import React from 'react';
import { AlertTriangle, X } from 'lucide-react';

export default function ConfirmModal({
  isOpen,
  title,
  message,
  confirmLabel = 'CONFIRM',
  cancelLabel = 'CANCEL',
  onConfirm,
  onCancel,
  variant = 'danger',
}) {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center modal-overlay">
      <div
        className="w-full max-w-md mx-4 paper-texture border-2 border-foreground ink-shadow"
        style={{ animation: 'fadeScaleIn 150ms ease forwards' }}
      >
        <div className="flex items-center justify-between p-4 border-b-2 border-foreground">
          <div className="flex items-center gap-2">
            <AlertTriangle
              size={18}
              style={{ color: variant === 'danger' ? 'var(--danger)' : 'var(--amber)' }}
            />
            <h3
              className="font-heading text-base tracking-stamp"
              style={{ fontFamily: 'var(--font-heading)' }}
            >
              {title.toUpperCase()}
            </h3>
          </div>
          <button onClick={onCancel} className="p-1 hover:opacity-70 transition-opacity">
            <X size={16} />
          </button>
        </div>
        <div className="p-4">
          <p className="text-sm text-muted-foreground">{message}</p>
        </div>
        <div className="flex gap-3 p-4 border-t border-border">
          <button onClick={onCancel} className="btn-secondary flex-1 px-4 py-2 text-sm">
            {cancelLabel}
          </button>
          <button
            onClick={onConfirm}
            className={`flex-1 px-4 py-2 text-sm ${variant === 'danger' ? 'btn-danger' : 'btn-primary'}`}
          >
            {confirmLabel}
          </button>
        </div>
      </div>
    </div>
  );
}
